/* eslint-disable */
import axios from 'axios'

const baseUrl = process.env.VUE_APP_BASE_API + "/excursion/hotel-pickups/";


const state = {
    hotelStopGroups: [],
    hotelEdit: {},
    groupBulkPickupEdit: {},
    forceUIReload: false
}

const actions = {
    async getHotelStopGroupsBySuprazone({
        commit, dispatch
    }, data ) {
        commit("ISLOADING", ["default", true], {
            root: true,
        });
        await axios
            .get(
                baseUrl + 'list_by_suprazone/' + 
                '?suprazone_id=' + data.suprazone_id
            ).then(response => {
                commit('SET_HOTEL_STOPS_GROUPS', response.data)
                return response.data
            }).finally( () => {
                commit("ISLOADING", ["default", false], {
                    root: true,
                });
            })
    },
    storeHotelEdit({
        commit, dispatch
    }, data) {
        commit('SET_HOTEL_EDIT', data.hotel)
    },
    storeGroupBulkPickupEdit({
        commit, dispatch
    }, data) {
        commit('SET_BULK_PICKUP_EDIT', data)
    },
    async saveHotelStopGroupRelation({
        commit, dispatch
    }, data) {
        commit("ISLOADING", ["default", true], {
            root: true,
        });
        await axios
            .post(
                baseUrl,
                data
            ).then(response => {
                return response.data
            }).catch( error => {
                if ( error.response.data.error.includes('duplicate') ) {
                    this._vm.$notify({
                        group: "foo",
                        title: "Relación guardada",
                        text: 'La relación hotel, parada y grupo de actividad se ha guardado satisfactoriamente',
                        type: "success",
                    });
                } else {
                    this._vm.$notify({
                        group: "foo",
                        title: "Error al guardar",
                        text: error + ' ' + JSON.stringify(error.response.data),
                        type: "error",
                    });
                    throw new Error(error) 
                }
            }).finally( () => {
                commit("ISLOADING", ["default", false], {
                    root: true,
                });
            })
    },
    async copyFromGroup({
        commit, dispatch
    }, data) {
        await axios
            .post(
                baseUrl + 'copy_from_activity_group/',
                data
            ).then( response => {

                return response.data
            }).catch( error => {
                this._vm.$notify({
                    group: "foo",
                    title: "Error al guardar",
                    text: error + ' ' + JSON.stringify(error.response.data),
                    type: "error",
                });
                throw new Error(error) 
            }).finally( () => {
                commit('SET_FORCE_UI_RELOAD', true)
            }) 
    },
    forceUIReload({
        commit, dispatch
    }, data) {
        commit('SET_FORCE_UI_RELOAD', data.value)
    },
    async reset({
        commit, dispatch
    }, data) {
        await axios
            .post(
                baseUrl + 'reset/?activity_group_id=' + data.activity_group_id
            ).then(response => {
                return response.data
            }).catch( error => {
                this._vm.$notify({
                    group: "foo",
                    title: "Error al eliminar",
                    text: error + ' ' + JSON.stringify(error.response.data),
                    type: "error",
                });
                throw new Error(error) 
            }).finally( () => {
                commit('SET_FORCE_UI_RELOAD', true)
            }) 
    },
    async setGroupBulkPickupEdit({
        commit, dispatch
    }, data) {
        commit("ISLOADING", ["default", true], {
            root: true,
        });
        await axios
            .post(
                baseUrl + 'bulk_assign_pickup/',
                data
            ).then( response => {

                return response.data
            }).catch( error => {
                this._vm.$notify({
                    group: "foo",
                    title: "Error al guardar",
                    text: error + ' ' + JSON.stringify(error.response.data),
                    type: "error",
                });
                throw new Error(error) 
            }).finally( () => {
                commit('SET_FORCE_UI_RELOAD', true)
                commit("ISLOADING", ["default", false], {
                    root: true,
                });
            }) 
    },
 
 }

const mutations = {
    SET_HOTEL_STOPS_GROUPS(state, hotel_stop_groups) {
        state.hotelStopGroups = hotel_stop_groups
    },
    SET_HOTEL_EDIT(state, hotel) {
        state.hotelEdit = hotel
    },
    SET_BULK_PICKUP_EDIT(state, data) {
        state.groupBulkPickupEdit = {
            suprazone: data.suprazone,
            activity_group: data.activity_group,
            pickup_point: data.pickup_point
        }
    },
    SET_FORCE_UI_RELOAD(state, value) {
        state.forceUIReload = value
    },
    RESET_HOTEL_STOPS_GROUPS(state) {
        state.hotelStopGroups = []
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
  }